import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, Button } from '@mui/material';
import { listClients } from '../utils/api';
import { useNavigate } from 'react-router-dom';

const VendorOverview: React.FC = () => {
  const [clients, setClients] = useState<any[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetchClients();
  }, []);

  const fetchClients = async () => {
    try {
      const response = await listClients();
      setClients(response.data.data.clients);
    } catch (err) {
      console.error('Failed to fetch clients', err);
    }
  };

  return (
    <div>
      <h2>Client Vendor Overview</h2>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {clients.map((client) => (
            <TableRow key={client.id}>
              <TableCell>{client.id}</TableCell>
              <TableCell>{client.client_name}</TableCell>
              <TableCell>
                <Button onClick={() => navigate(`/superadmin/vendors/${client.id}`)}>
                  View Vendors
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default VendorOverview;